module.exports = __webpack_public_path__ + "prod/1.42.2/img/system-three.172d2987.png";